<template>
<div class="localUserConfiguration">
  <el-form ref="form" :inline="true" :model="formData">
    <!-- <el-form-item>
      <el-button icon="el-icon-back" type="primary" @click="goBack()" style="margin-left: 10px;">返回项目列表</el-button>
    </el-form-item> -->
    <el-form-item>
      <el-button type="primary" @click="onAdd">添加</el-button>
    </el-form-item>
  </el-form>
  <el-card class="box-card" shadow="never">{{ projectName }}</el-card>
  <div class="content">
    <el-table ref="table" :data="tableData" border height="52vh" style="width: 100%;">
      <el-table-column prop="username" label="用户名"></el-table-column>
      <el-table-column prop="authorization" label="权限">
        <template slot-scope="{ row }">
          {{ row.authorization==1?'监视':row.authorization==2?'控制':'监控' }}
        </template>
      </el-table-column>
      <el-table-column prop="expirationTime" label="下置数据过期时间">
        <template slot-scope="{ row }">
          {{ Math.floor(row.expirationTime / 3600) + "时" + Math.floor((row.expirationTime - Math.floor(row.expirationTime / 3600) * 3600) / 60) + "分" + Math.floor((row.expirationTime - Math.floor(row.expirationTime / 3600) * 3600 - Math.floor((row.expirationTime - Math.floor(row.expirationTime / 3600) * 3600) / 60) * 60)) + "秒" }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button @click="onEdit(scope.row)" type="text" size="small">编辑</el-button>
          <el-button @click="onDelete(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formData.pageNum" :page-sizes="pageList" :page-size="formData.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="text-align: center;margin-top: 15px;"></el-pagination>
  </div>
  <Dialog ref="addLocalConfigDialog" title="添加用户">
    <el-form :model="addDialogData" label-width="150px">
      <el-form-item label="用户名:" prop="username">
        <el-input v-model="addDialogData.username" placeholder="用户名" style="width: 75%;"></el-input>
      </el-form-item>
      <el-form-item label="密码:" prop="password">
        <el-input v-model="addDialogData.password" placeholder="密码" autocomplete="off" style="width: 75%;"></el-input>
      </el-form-item>
      <el-form-item label="权限:" prop="authorization">
        <el-radio-group v-model="addDialogData.authorization">
          <el-radio :label="1">监视</el-radio>
          <el-radio :label="2">控制</el-radio>
          <el-radio :label="3">监控</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="下置数据过期时间:" :model="addDialogData.expirationTime">
        <el-col :span="8">
          <el-input v-model.number="addDialogData.expirationTime.eHour" placeholder="时" style="width: 70%;"></el-input><span style="margin-left: 5px;">时</span>
        </el-col>
        <el-col :span="8">
          <el-input v-model.number="addDialogData.expirationTime.eMinutes" placeholder="分" style="width: 70%;"></el-input><span style="margin-left: 5px;">分</span>
        </el-col>
        <el-col :span="8">
          <el-input v-model.number="addDialogData.expirationTime.eSecond" placeholder="秒" style="width: 70%;"></el-input><span style="margin-left: 5px;">秒</span>
        </el-col>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button type="primary" @click="onAddSubmit()">提交</el-button>
    </template>
  </Dialog>
  <Dialog ref="editLocalConfigDialog" title="编辑用户">
    <el-form :model="editDialogData" label-width="150px">
      <el-form-item label="用户名:" prop="username">
        <el-input v-model="editDialogData.username" placeholder="用户名" style="width: 75%;"></el-input>
      </el-form-item>
      <el-form-item label="密码:" prop="password">
        <el-input v-model="editDialogData.password" placeholder="密码" :readonly="showPassword" :show-password="showPassword" autocomplete="off" style="width: 75%;"></el-input>
        <i v-if="showPassword" class="el-icon-edit" @click="editPwd()"></i>
        <span v-if="!showPassword">
          <i class="el-icon-close" @click="showPassword=true"></i>
        </span>
      </el-form-item>
      <el-form-item label="权限:" prop="authorization">
        <el-radio-group v-model="editDialogData.authorization">
          <el-radio :label="1">监视</el-radio>
          <el-radio :label="2">控制</el-radio>
          <el-radio :label="3">监控</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="下置数据过期时间:" :model="editDialogData.expirationTime">
        <el-col :span="8">
          <el-input v-model.number="editDialogData.expirationTime.eHour" placeholder="时" style="width: 70%;"></el-input><span style="margin-left: 5px;">时</span>
        </el-col>
        <el-col :span="8">
          <el-input v-model.number="editDialogData.expirationTime.eMinutes" placeholder="分" style="width: 70%;"></el-input><span style="margin-left: 5px;">分</span>
        </el-col>
        <el-col :span="8">
          <el-input v-model.number="editDialogData.expirationTime.eSecond" placeholder="秒" style="width: 70%;"></el-input><span style="margin-left: 5px;">秒</span>
        </el-col>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button type="primary" @click="onEditSubmit()">提交</el-button>
    </template>
  </Dialog>
</div>
</template>

<script>
import PROJECTAPI from '@/api/project';
import Dialog from '@/components/dialog';
export default {
  props: {
    projectId: {
      type: [String, Number]
    },
    projectName: {
      type: [String, Number]
    }
  },
  data() {
    return {
      formData: {
        pageNum: 1,
        pageSize: 10,
        projectId: ''
      },
      total: 0,
      pageList: [10, 20, 30, 50, 100],
      tableData: [],
      addDialogData: {
        username: '',
        password: '',
        authorization: 1,
        expirationTime: {
          eHour: '',
          eMinutes: '',
          eSecond: '',
        }
      },
      editDialogData: {
        username: '',
        password: '',
        authorization: '',
        expirationTime: {
          eHour: '',
          eMinutes: '',
          eSecond: '',
        }
      },
      currRow: {},
      showPassword: true
    };
  },
  components: {
    Dialog
  },
  mounted() {
    this.formData.projectId = this.projectId;
    this.getLocalUserList();
  },
  methods: {
    goBack() {
      this.$emit("goBack", false);
    },
    getLocalUserList() {
      let params = this.formData;
      PROJECTAPI.getLocalUserList(params).then(res => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    onAdd() {
      this.$refs.addLocalConfigDialog.open();
    },
    onAddSubmit() {
      let h = this.addDialogData.expirationTime.eHour;
      let m = this.addDialogData.expirationTime.eMinutes;
      let s = this.addDialogData.expirationTime.eSecond;
      this.addDialogData.projectId = this.projectId;
      this.addDialogData.expirationTime = h * 3600 + m * 60 + s;
      let params = this.addDialogData;
      PROJECTAPI.addLocalUser(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success(res.data.data);
          this.getLocalUserList();
        }
        this.$refs.addLocalConfigDialog.close();
      });
    },
    onEdit(row) {
      this.editDialogData.expirationTime = {
        eHour: "",
        eMinutes: "",
        eSecond: ""
      };
      this.showPassword = true;
      this.$refs.editLocalConfigDialog.open();
      this.editDialogData.id = row.id;
      this.editDialogData.username = row.username;
      this.editDialogData.password = row.password;
      this.editDialogData.authorization = row.authorization;
      if (row.expirationTime == 0) {
        this.editDialogData.expirationTime.eHour = 0;
        this.editDialogData.expirationTime.eMinutes = 0;
        this.editDialogData.expirationTime.eSecond = 0;
      } else {
        let h = Math.floor(row.expirationTime / 3600);
        this.editDialogData.expirationTime.eHour = h; 
        let m = Math.floor((row.expirationTime - h * 3600) / 60);
        this.editDialogData.expirationTime.eMinutes = m;
        let s = Math.floor((row.expirationTime - h * 3600 - m * 60));
        this.editDialogData.expirationTime.eSecond = s;
      }
    },
    onEditSubmit() {
      let h = this.editDialogData.expirationTime.eHour;
      let m = this.editDialogData.expirationTime.eMinutes;
      let s = this.editDialogData.expirationTime.eSecond;
      this.editDialogData.projectId = this.projectId;
      this.editDialogData.expirationTime = h * 3600 + m * 60 + s;
      let params = this.editDialogData;
      PROJECTAPI.updateLocalUser(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success(res.data.data);
          this.getLocalUserList();
        }
      });
      this.$refs.editLocalConfigDialog.close();
    },
    editPwd() {
      this.showPassword = false;
    },
    onDelete(row) {
      this.currRow = row;
      let self = this;
      this.$confirm('是否删除此用户？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.delLocalUser();
        })
        .catch(() => {});
    },
    delLocalUser() {
      let params = {
        localUserInfoId: this.currRow.id
      };
      PROJECTAPI.delLocalUser(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("删除成功！");
          this.getLocalUserList();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg
          });
        }
      });
    },
    handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getLocalUserList();
    },
    handleCurrentChange(val) {
      this.formData.pageNum = val;
      this.getLocalUserList();
    },
  }
};
</script>

<style lang="scss">
.localUserConfiguration {
  background: #fff;
  height: 70vh;

  .el-card__header {
    font-weight: bold;
    background: #f0f2f5;
    text-align: center;
  }

  .content {
    padding: 20px 0px;
  }

  .el-icon-edit,
  .el-icon-close {
    cursor: pointer;
    margin-left: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/project/localUserConfiguration.vue